// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsPaymentWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsPaymentWebApiHandler_previewApplicationPayment,
  CappsPaymentWebApiHandler_previewApplicationPayment_Path,
  CappsPaymentWebApiHandler_startPaymentMethodSession,
  CappsPaymentWebApiHandler_submitApplicationPayment,
} from '@zg-rentals/ts-capps-client';

import type {
  PreviewApplicationPaymentWebApiResponseDto,
  StartPaymentMethodSessionWebApiRequestDto,
  StartPaymentMethodSessionWebApiResponseDto,
  SubmitApplicationPaymentWebApiRequestDto,
  SubmitOrderWebApiResponseDto,
} from '@zg-rentals/ts-capps-client';

interface PreviewApplicationPaymentParams {
  city: string;
  country: string;
  postalCode: string;
  stateOrProvince: string;
}

export type CappsPaymentWebApiHandler_previewApplicationPayment_Options = UseQueryOptions<
  PreviewApplicationPaymentWebApiResponseDto,
  unknown,
  PreviewApplicationPaymentWebApiResponseDto,
  readonly [string, PreviewApplicationPaymentParams]
>;

const CappsPaymentWebApiHandler_previewApplicationPayment_GetKey = (getParams: PreviewApplicationPaymentParams) =>
  [CappsPaymentWebApiHandler_previewApplicationPayment_Path, getParams] as const;

export const CappsPaymentWebApiHandler_previewApplicationPayment_queryOptions = (
  getParams: PreviewApplicationPaymentParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsPaymentWebApiHandler_previewApplicationPayment_GetKey(getParams),
    queryFn: () => CappsPaymentWebApiHandler_previewApplicationPayment(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsPaymentWebApiHandler_previewApplicationPayment = (
  getParams: PreviewApplicationPaymentParams,
  {
    httpClient,
    ...options
  }: Omit<CappsPaymentWebApiHandler_previewApplicationPayment_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsPaymentWebApiHandler_previewApplicationPayment_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsPaymentWebApiHandler_previewApplicationPayment.getKey =
  CappsPaymentWebApiHandler_previewApplicationPayment_GetKey;

export interface CappsPaymentWebApiHandler_startPaymentMethodSession_Args {
  postData: StartPaymentMethodSessionWebApiRequestDto;
}

export type CappsPaymentWebApiHandler_startPaymentMethodSession_Options = UseMutationOptions<
  StartPaymentMethodSessionWebApiResponseDto,
  unknown,
  CappsPaymentWebApiHandler_startPaymentMethodSession_Args
>;

export const useCappsPaymentWebApiHandler_startPaymentMethodSession = ({
  httpClient,
  ...options
}: Omit<CappsPaymentWebApiHandler_startPaymentMethodSession_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsPaymentWebApiHandler_startPaymentMethodSession_Args) =>
      CappsPaymentWebApiHandler_startPaymentMethodSession(args.postData, httpClient),
  });
};

export interface CappsPaymentWebApiHandler_submitApplicationPayment_Args {
  postData: SubmitApplicationPaymentWebApiRequestDto;
}

export type CappsPaymentWebApiHandler_submitApplicationPayment_Options = UseMutationOptions<
  SubmitOrderWebApiResponseDto,
  unknown,
  CappsPaymentWebApiHandler_submitApplicationPayment_Args
>;

export const useCappsPaymentWebApiHandler_submitApplicationPayment = ({
  httpClient,
  ...options
}: Omit<CappsPaymentWebApiHandler_submitApplicationPayment_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsPaymentWebApiHandler_submitApplicationPayment_Args) =>
      CappsPaymentWebApiHandler_submitApplicationPayment(args.postData, httpClient),
  });
};
